module.exports = __webpack_public_path__ + "static/media/loginbutton.f5c720f3.png";